<!-- <p>register-user works!</p> -->
<form [formGroup]='regForm' class="p-3">
    <!-- General Details -->
    <div class="row">
        <div class="card colorborder col-lg-12">
            <div class="card card-header">
                <h3>General Details</h3>
            </div>
            <div class="card card-body">
                <div class="row">
                    <div class="col-lg-3 form-group">
                        <label>Entity Type<span class="red">*</span></label>
                        <select class="form-control form-control-sm selectpicker" formControlName="entityType"
                            title="Select Entity Type" data-live-search="true"
                            [ngClass]="{'is-invalid': (submitted || rf.entityType.touched) && rf.entityType.errors}">
                            <option value="">Select Entity Type</option>
                            <option *ngFor="let data of entityList" value="{{data.key}}">{{data.key+" - "+data.value}}
                            </option>
                        </select>
                        <p *ngIf="(submitted || rf.entityType.touched) && rf.entityType.errors?.required" class="error">
                            Please select entity type</p>
                    </div>
                    <div class="col-lg-3 form-group">
                        <label>Participant Name<span class="red">*</span></label>
                        <input class="form-control form-control-sm" formControlName="pname"
                            [ngClass]="{'is-invalid': (submitted || rf.pname.touched) && rf.pname.errors }" autocomplete="off">
                        <p *ngIf="(submitted || rf.pname.touched) && rf.pname.errors?.required" class="error">
                            Please enter participant name</p>
                    </div>
                    <!-- <div class="col-lg-3 form-group">
                        <label>Login ID<span class="red">*</span></label>
                        <input class="form-control form-control-sm" formControlName="loginName"
                            (change)="checkLoginId()"
                            [ngClass]="{'is-invalid': (!validUserLoginId && rf.loginName.touched) || ((submitted || rf.loginName.touched) && rf.loginName.errors), 'is-valid':validUserLoginId}">
                        <p *ngIf="(submitted || rf.loginName.touched) && rf.loginName.errors?.required" class="error">
                            Please enter login ID</p>
                        <p *ngIf="(submitted || rf.loginName.touched) && rf.loginName.errors?.pattern"
                            class="error nocase">
                            Login ID should start with alphanumeric character. It should contain at least 5
                            characters & should not contain any white spaces.
                        </p>
                    </div> -->
                    <div class="col-lg-3 form-group">
                        <label>PAN</label>
                        <input type="text" class="form-control form-control-sm" formControlName="pan"
                            [ngClass]="{'is-invalid': (submitted || rf.pan.touched) && rf.pan.errors}" autocomplete="off">
                        <p *ngIf="(submitted || rf.pan.touched) && rf.pan.errors?.pattern" class="error">First 5
                            characters should be uppercase alphabets, followed by 4 numeric digits and then an uppercase
                            alphabet.</p>
                    </div>
                    <div class="col-lg-3 form-group">
                        <label>Custodian Name</label>
                        <input class="form-control form-control-sm" formControlName="custodian"
                            [ngClass]="{'is-invalid': (submitted || rf.custodian.touched) && rf.custodian.errors}" autocomplete="off">
                    </div>

                    <!-- <div class="row"> -->
                    <!-- <div class="col-lg-3 form-group">
                        <label>Repo Eligible<span class="red">*</span></label>
                        <select class="form-control form-control-sm" formControlName="repoEligible"
                            [ngClass]="{'is-invalid': (submitted || rf.repoEligible.touched) && rf.repoEligible.errors}"
                            data-style="btn-info">
                            <option value="Y">YES</option>
                            <option value="N">NO</option>
                        </select>
                    </div>
                    <div class="col-lg-3 form-group">
                        <label>Enable Settlement Notifications<span class="red">*</span></label>
                        <select class="form-control form-control-sm" formControlName="enableSettleNotification"
                            [ngClass]="{'is-invalid': (submitted || rf.enableSettleNotification.touched) && rf.enableSettleNotification.errors}"
                            data-style="btn-info">
                            <option value="Y">YES</option>
                            <option value="N">NO</option>
                        </select>
                    </div> -->
                    <!-- </div> -->
                    <div class="col-lg-3 form-group">
                        <legend class="mt-1">Regulated By<!--<span class="red">*</span>--></legend>
                        <div class="form-check form-check-inline">
                            <input type="checkbox" formControlName="regulatedBySEBI" name="regulatedBySEBI"
                                id="regulatedBySEBI" value="SEBI" class="form-check-input" (change)="detectChange()">
                            <label class="form-check-label" for="regulatedBySEBI">SEBI</label>
                        </div>
                        <div class="form-check form-check-inline ml-3">
                            <input type="checkbox" formControlName="regulatedByRBI" name="regulatedByRBI"
                                id="regulatedByRBI" value="RBI" class="form-check-input" (change)="detectChange()">
                            <label class="form-check-label" for="regulatedByRBI">RBI</label>
                        </div>
                        <div class="form-check form-check-inline ml-3">
                            <input type="checkbox" formControlName="regulatedByIFSCA" name="regulatedByIFSCA"
                                id="regulatedByIFSCA" value="IFSCA" class="form-check-input" (change)="detectChange()">
                            <label class="form-check-label" for="regulatedByIFSCA">IFSCA</label>
                        </div>
                        <!-- <p *ngIf="(submitted || rf.regulatedBySEBI.touched || rf.regulatedByRBI.touched || rf.regulatedByIFSCA.touched) && !(rf.regulatedBySEBI.value || rf.regulatedByRBI.value || rf.regulatedByIFSCA.value)"
                            class="error">
                            Please select Regulated By</p> -->
                    </div>
                    <div class="col-lg-3 form-group" *ngIf="rf.regulatedBySEBI.value">
                        <label>SEBI Registration Number<span class="red">*</span></label>
                        <input class="form-control form-control-sm" formControlName="sebiRegNo"
                            [required]="rf.regulatedBySEBI.value?true:null"
                            [ngClass]="{'is-invalid': (submitted || rf.sebiRegNo.touched) && rf.sebiRegNo.errors}" autocomplete="off">
                        <p *ngIf="(submitted || rf.sebiRegNo.touched) && rf.sebiRegNo.errors?.required" class="error">
                            Please enter SEBI registration number</p>
                    </div>
                    <div class="col-lg-3 form-group" *ngIf="rf.regulatedByRBI.value">
                        <label>RBI Registration Number<span class="red">*</span></label>
                        <input class="form-control form-control-sm" formControlName="rbiRegNo"
                            [required]="rf.regulatedByRBI.value?true:null"
                            [ngClass]="{'is-invalid': (submitted || rf.rbiRegNo.touched) && rf.rbiRegNo.errors}" autocomplete="off">
                        <p *ngIf="(submitted || rf.rbiRegNo.touched) && rf.rbiRegNo.errors?.required" class="error">
                            Please enter RBI registration number</p>
                    </div>
                    <div class="col-lg-3 form-group" *ngIf="rf.regulatedByIFSCA.value">
                        <label>IFSCA Registration Number<span class="red">*</span></label>
                        <input class="form-control form-control-sm" formControlName="ifscaRegNo"
                            [required]="rf.regulatedByIFSCA.value?true:null"
                            [ngClass]="{'is-invalid': (submitted || rf.ifscaRegNo.touched) && rf.ifscaRegNo.errors}" autocomplete="off">
                        <p *ngIf="(submitted || rf.ifscaRegNo.touched) && rf.ifscaRegNo.errors?.required" class="error">
                            Please enter IFSCA registration number</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- Contact Details -->
        <div class="card colorborder mt-3 col-lg-6">
            <div class="card card-header">
                <h3>Authorised Signatory <small>(for future communication)</small></h3>
            </div>
            <div class="card card-body">
                <div class="row ">
                    <div class="col-lg-6 form-group">
                        <label>Authorised Signatory Name<span class="red">*</span></label>
                        <input class="form-control form-control-sm" formControlName="contactPersonName"
                            [ngClass]="{'is-invalid': (submitted || rf.contactPersonName.touched) && rf.contactPersonName.errors}" autocomplete="off">
                        <p *ngIf="(submitted || rf.contactPersonName.touched) && rf.contactPersonName.errors?.required"
                            class="error">
                            Please enter authorised signatory name</p>
                    </div>
                    <div class="col-lg-6 form-group">
                        <label>Mobile Number<span class="red">*</span></label>
                        <div class="input-group input-group-sm">
                            <div class="input-group-prepend">
                                <div class="input-group-text"><i class="fa fa-plus" aria-hidden="true"></i></div>
                            </div>
                            <input type="text" value="" class="form-control form-control-sm"
                                formControlName="countryCode"
                                [ngClass]="{'is-invalid': (submitted || rf.countryCode.touched) && rf.countryCode.errors}"
                                placeholder="Enter Country Code" autocomplete="off">
                            <div class="input-group-append w-75">
                                <input type="text" value="" class="form-control form-control-sm"
                                    formControlName="mobile"
                                    [ngClass]="{'is-invalid': (submitted || rf.mobile.touched) && rf.mobile.errors}"
                                    placeholder="Enter Mobile Number" autocomplete="off">
                            </div>
                        </div>
                        <p *ngIf="(submitted || rf.countryCode.touched) && rf.countryCode.errors?.required"
                            class="error">
                            Please enter country code</p>
                        <p *ngIf="(submitted || rf.countryCode.touched) && rf.countryCode.errors?.pattern"
                            class="error">
                            Please enter valid country code</p>
                        <p *ngIf="(submitted || rf.mobile.touched) && rf.mobile.errors?.required" class="error">
                            Please enter mobile number</p>
                        <p *ngIf="(submitted || rf.mobile.touched) && rf.mobile.errors?.pattern" class="error">
                            Please enter valid mobile number</p>
                    </div>
                    <div class="col-lg-6 form-group">
                        <label>Email ID<span class="red">*</span></label>
                        <input class="form-control form-control-sm" formControlName="email" readonly
                            [ngClass]="{'is-invalid': (submitted || rf.email.touched) && rf.email.errors}" autocomplete="off">
                        <p *ngIf="(submitted || rf.email.touched) && rf.email.errors?.required" class="error">
                            Please enter email id</p>
                        <p *ngIf="(submitted || rf.email.touched) && rf.email.errors?.email" class="error">
                            Please enter valid email id</p>
                    </div>
                    <!-- <div class="col-lg-6 form-group">
                        <label>Fax<span class="red">*</span></label>
                        <input class="form-control form-control-sm" formControlName="fax"
                            [ngClass]="{'is-invalid': (submitted || rf.fax.touched) && rf.fax.errors}">
                    </div> -->
                    <div class="col-lg-6 form-group">
                        <label>Address Line 1<!--<span class="red">*</span>--></label>
                        <input class="form-control form-control-sm" formControlName="addrLine1"
                            [ngClass]="{'is-invalid': (submitted || rf.addrLine1.touched) && rf.addrLine1.errors}" autocomplete="off">
                        <!-- <p *ngIf="(submitted || rf.addrLine1.touched) && rf.addrLine1.errors?.required" class="error">
                            Please enter address</p> -->
                    </div>
                    <div class="col-lg-6 form-group">
                        <label>Address Line 2</label>
                        <input class="form-control form-control-sm" formControlName="addrLine2"
                            [ngClass]="{'is-invalid': (submitted || rf.addrLine2.touched) && rf.addrLine2.errors}" autocomplete="off">
                    </div>
                    <div class="col-lg-6 form-group">
                        <label>Address Line 3</label>
                        <input class="form-control form-control-sm" formControlName="addrLine3"
                            [ngClass]="{'is-invalid': (submitted || rf.addrLine3.touched) && rf.addrLine3.errors}" autocomplete="off">
                    </div>
                </div>
            </div>
        </div>
        <div class="card mt-3 colorborder col-lg-6">
            <!-- LEI Code -->
            <div class="card card-header colorborder">
                <h3>LEI Details</h3>
            </div>
            <div class="card card-body">
                <div class="row">
                    <div class="col-lg-6 form-group">
                        <label>LEI Code<!--<span class="red">*</span>--></label>
                        <input type="text" class="form-control form-control-sm" formControlName="leiCode"
                            [ngClass]="{'is-invalid': (submitted || rf.leiCode.touched) && rf.leiCode.errors}" autocomplete="off">
                        <!-- <p *ngIf="(submitted || rf.leiCode.touched) && rf.leiCode.errors?.required" class="error">Please
                            enter LEI code</p> -->
                        <p *ngIf="(submitted || rf.leiCode.touched) && rf.leiCode.errors?.pattern" class="error">LEI Code should contain 20 alphanumeric
                            characters.</p>
                    </div>
                    <div class="col-lg-6 form-group">
                        <label>Expiry Date<!--<span class="red">*</span>--></label>
                        <div class="input-group input-group-sm pointer">
                            <input type="text" class="form-control form-control-sm datepicker" [(bsValue)]="bsValue1"
                                value="{{bsValue1 | date:'dd/MM/yyyy'}}" formControlName="expiryDate" bsDatepicker
                                [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD/MM/YYYY'}" placeholder=""
                                [ngClass]="{'is-invalid': (submitted || rf.expiryDate.touched) && rf.expiryDate.errors}" autocomplete="off">
                            <div class="input-group-append">
                                <div class="input-group-text">
                                    <i class="fa fa-calendar" [(bsValue)]="bsValue1" bsDatepicker
                                        [ngClass]="rf.expiryDate.disabled?'disabled':''"
                                        [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD/MM/YYYY' }"></i>
                                </div>
                            </div>
                        </div>
                        <!-- <p *ngIf="(submitted || rf.expiryDate.touched) && rf.expiryDate.errors?.required" class="error">
                            Please enter expiry date</p> -->
                    </div>
                    <div class="col-lg-6 form-group">
                        <label>LEI Issuer Name<!--<span class="red">*</span>--></label>
                        <input type="text" class="form-control form-control-sm" formControlName="leiIssuer"
                            [ngClass]="{'is-invalid': (submitted || rf.leiIssuer.touched) && rf.leiIssuer.errors}" autocomplete="off">
                        <!-- <p *ngIf="(submitted || rf.leiIssuer.touched) && rf.leiIssuer.errors?.required" class="error">
                            Please enter LEI issuer name</p> -->
                    </div>
                    <!-- <div class="col-lg-3 form-group">
                        <label>LEI Document<span class="red">*</span></label>
                        <input type="file" class="form-control-file" formControlName="leiFile"
                            [ngClass]="{'is-invalid': (submitted || rf.leiFile.touched) && rf.leiFile.errors}">
                        <p *ngIf="(submitted || rf.leiFile.touched) && rf.leiFile.errors?.required" class="error">Please
                            upload LEI document</p>
                    </div> -->
                </div>
            </div>


        </div>
        <!-- GST Details -->
        <!-- <div class="card mt-3 colorborder col-lg-6">
            <div class="card card-header">
                <h3>GST Details</h3>
            </div>
            <div class="card card-body">
                <div class="row ">
                    <div class="col-lg-6 form-group">
                        <label>Registered Off/Domicile State<span class="red">*</span></label>
                        <select class="form-control form-control-sm selectpicker" formControlName="regOffState"
                            title="Select State" data-live-search="true"
                            [ngClass]="{'is-invalid': (submitted || rf.regOffState.touched) && rf.regOffState.errors}">
                            <option *ngFor="let data of stateList" value="{{data}}">{{data}}</option>
                        </select>
                        <p *ngIf="(submitted || rf.regOffState.touched) && rf.regOffState.errors?.required"
                            class="error">Please select registered office state</p>
                    </div>
                    <div class="col-lg-6 form-group">
                        <label>Registered Off/Domicile Address<span class="red">*</span></label>
                        <input type="text" class="form-control form-control-sm" formControlName="regOffAddress"
                            [ngClass]="{'is-invalid': (submitted || rf.regOffAddress.touched) && rf.regOffAddress.errors}">
                        <p *ngIf="(submitted || rf.regOffAddress.touched) && rf.regOffAddress.errors?.required"
                            class="error">Please enter registered office address</p>
                    </div>
                    <div class="col-lg-6 form-group">
                        <legend class="mt-1">GST Exempted<span class="red">*</span></legend>
                        <div class="form-check form-check-inline">
                            <input type="radio" formControlName="gstExempted" name="gstExempted" id="gstExemptedY"
                                value="Y" class="form-check-input">
                            <label class="form-check-label" for="gstExemptedY">Yes</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input type="radio" formControlName="gstExempted" name="gstExempted" id="gstExemptedN"
                                value="N" class="form-check-input">
                            <label class="form-check-label" for="gstExemptedN">No</label>
                        </div>
                    </div>
                    <div class="col-lg-6 form-group">
                        <label>GST No<span *ngIf="rf.gstExempted.value=='N'" class="red">*</span></label>
                        <input type="text" class="form-control form-control-sm" [required]="rf.gstExempted.value=='N'"
                            [attr.disabled]="rf.gstExempted.value=='Y'?true:null" formControlName="gstNo"
                            [ngClass]="{'is-invalid': (submitted || rf.gstNo.touched) && rf.gstNo.errors}">
                        <p *ngIf="(submitted || rf.gstNo.touched) && rf.gstNo.errors?.required" class="error">Please
                            enter GST number</p>
                        <p *ngIf="(submitted || rf.gstNo.touched) && rf.gstNo.errors?.pattern" class="error">First 2
                            characters should be numeric state code. Then 5 characters should be uppercase alphabets,
                            followed by 4 numeric digits, then an uppercase alphabet, then single digit numeric code
                            followed by character 'Z' and then a single alpha numeric character.</p>
                    </div>
                </div>
            </div>
        </div> -->

        <!-- <div class="card mt-3 colorborder col-lg-6">
            
        </div> -->
        <!-- Bank Accounts -->
        <div class="card mt-3 colorborder col-lg-12">
            <div class="card card-header">
                <h3>Participant Bank Accounts</h3>
            </div>
            <!-- table start -->
            <div class="card card-body table-responsive">
                <table class="table common-table common-table">
                    <thead>
                        <tr>
                            <th>Sr. No.</th>
                            <th>Bank Name<!--<span class="red">*</span>--></th>
                            <th>Bank IFSC/BIC Code<!--<span class="red">*</span>--></th>
                            <th>Re-Enter Bank IFSC/BIC Code<!--<span class="red">*</span>--></th>
                            <!-- <th>Inter Bank Account<span class="red">*</span></th> -->
                            <th>Bank Account No/Nostro Account No<!--<span class="red">*</span>--></th>
                            <th>Re-Enter Bank Account No/Nostro Account No<!--<span class="red">*</span>--></th>
                            <!-- <th>Default<span class="red">*</span></th> -->
                            <!-- <th>Upload Bank Statement<span class="red">*</span></th> -->
                            <!-- <th></th> -->
                        </tr>
                    </thead>
                    <tbody formArrayName="bankAccountDTOList">
                        <tr *ngFor="let data of rf.bankAccountDTOList['controls']; let i=index" [formGroupName]="i">
                            <td>{{i+1}}</td>
                            <td>
                                <input type="text" class="form-control form-control-sm" formControlName="bankName"
                                    [ngClass]="{'is-invalid': (submitted || rf.bankAccountDTOList['controls'][i]['controls'].bankName.touched) && rf.bankAccountDTOList['controls'][i]['controls'].bankName.errors}" autocomplete="off">
                                <!-- <p *ngIf="(submitted || rf.bankAccountDTOList['controls'][i]['controls'].bankName.touched) && rf.bankAccountDTOList['controls'][i]['controls'].bankName.errors?.required"
                                    class="error">Please enter bank name</p> -->
                            </td>
                            <td>
                                <input type="password" class="form-control form-control-sm" formControlName="bankIFSC"
                                    [ngClass]="{'is-invalid': (submitted || rf.bankAccountDTOList['controls'][i]['controls'].bankIFSC.touched) && rf.bankAccountDTOList['controls'][i]['controls'].bankIFSC.errors}" autocomplete="off">
                                <!-- <p *ngIf="(submitted || rf.bankAccountDTOList['controls'][i]['controls'].bankIFSC.touched) && rf.bankAccountDTOList['controls'][i]['controls'].bankIFSC.errors?.required"
                                    class="error">Please enter bank IFSC code/BIC code</p> -->
                                <p *ngIf="(submitted || rf.bankAccountDTOList['controls'][i]['controls'].bankIFSC.touched) && rf.bankAccountDTOList['controls'][i]['controls'].bankIFSC.errors?.pattern"
                                    class="error">First 4 characters should be uppercase alphabets, followed by 7
                                    alphanumeric characters.</p>
                            </td>
                            <td>
                                <input type="text" class="form-control form-control-sm"
                                    formControlName="reenteredBankIFSC"
                                    [ngClass]="{'is-invalid': (submitted || rf.bankAccountDTOList['controls'][i]['controls'].reenteredBankIFSC.touched) && rf.bankAccountDTOList['controls'][i]['controls'].reenteredBankIFSC.errors}" autocomplete="off">
                                <!-- <p *ngIf="(submitted || rf.bankAccountDTOList['controls'][i]['controls'].reenteredBankIFSC.touched) && rf.bankAccountDTOList['controls'][i]['controls'].reenteredBankIFSC.errors?.required"
                                    class="error">Please enter bank IFSC code/BIC code</p> -->
                                <p *ngIf="(submitted || rf.bankAccountDTOList['controls'][i]['controls'].reenteredBankIFSC.touched) && rf.bankAccountDTOList['controls'][i]['controls'].reenteredBankIFSC.errors?.matching"
                                    class="error">Re-entered IFSC code/BIC code should be same as bank IFSC code/BIC
                                    code</p>
                            </td>
                            <!-- <td>
                                <div class="form-check form-check-inline">
                                    <input type="radio" formControlName="interBankAccount" name="interBankAccount{{i}}"
                                        id="interBankYes" value="Y" class="form-check-input"
                                        [ngClass]="{'is-invalid': submitted && rf.bankAccountDTOList['controls'][i]['controls'].interBankAccount.errors}">
                                    <label class="form-check-label" for="interBankYes">Yes</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input type="radio" formControlName="interBankAccount" name="interBankAccount{{i}}"
                                        id="interBankNo" value="N" class="form-check-input"
                                        [ngClass]="{'is-invalid': submitted && rf.bankAccountDTOList['controls'][i]['controls'].interBankAccount.errors}">
                                    <label class="form-check-label" for="interBankNo">No</label>
                                </div>
                                <p *ngIf="(submitted || rf.bankAccountDTOList['controls'][i]['controls'].interBankAccount.touched) && rf.bankAccountDTOList['controls'][i]['controls'].interBankAccount.errors?.required"
                                    class="error">Please select inter bank account</p>
                            </td> -->
                            <td>
                                <input type="password" class="form-control form-control-sm"
                                    [ngClass]="{'is-invalid': (submitted || rf.bankAccountDTOList['controls'][i]['controls'].bankAccountNo.touched) && rf.bankAccountDTOList['controls'][i]['controls'].bankAccountNo.errors}"
                                    formControlName="bankAccountNo" autocomplete="off">
                                <!-- <p *ngIf="(submitted || rf.bankAccountDTOList['controls'][i]['controls'].bankAccountNo.touched) && rf.bankAccountDTOList['controls'][i]['controls'].bankAccountNo.errors?.required"
                                    class="error">Please enter bank account number/nostro account number</p> -->
                            </td>
                            <td>
                                <input type="text" class="form-control form-control-sm"
                                    [ngClass]="{'is-invalid': (submitted || rf.bankAccountDTOList['controls'][i]['controls'].reenterBankAccountNo.touched) && rf.bankAccountDTOList['controls'][i]['controls'].reenterBankAccountNo.errors}"
                                    formControlName="reenterBankAccountNo" autocomplete="off">
                                <!-- <p *ngIf="(submitted || rf.bankAccountDTOList['controls'][i]['controls'].reenterBankAccountNo.touched) && rf.bankAccountDTOList['controls'][i]['controls'].reenterBankAccountNo.errors?.required"
                                    class="error">Please enter bank account number</p> -->
                                <p *ngIf="(submitted || rf.bankAccountDTOList['controls'][i]['controls'].reenterBankAccountNo.touched) && rf.bankAccountDTOList['controls'][i]['controls'].reenterBankAccountNo.errors?.matching"
                                    class="error">Re-entered bank account number/nostro account number should be same as
                                    bank account number/nostro account number
                                </p>
                            </td>
                            <!-- <td>
                                <div class="form-check form-check-inline">
                                    <input type="radio" formControlName="defaultAccount" name="defaultBank{{i}}"
                                        id="defaultYes" value="Y" class="form-check-input"
                                        [ngClass]="{'is-invalid': submitted && rf.bankAccountDTOList['controls'][i]['controls'].defaultAccount.errors}">
                                    <label class="form-check-label" for="defaultYes">Yes</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input type="radio" formControlName="defaultAccount" name="defaultBank{{i}}"
                                        id="defaultNo" value="N" class="form-check-input"
                                        [ngClass]="{'is-invalid': submitted && rf.bankAccountDTOList['controls'][i]['controls'].defaultAccount.errors}">
                                    <label class="form-check-label" for="defaultNo">No</label>
                                </div>
                                <p *ngIf="(submitted || rf.bankAccountDTOList['controls'][i]['controls'].defaultAccount.touched) && rf.bankAccountDTOList['controls'][i]['controls'].defaultAccount.errors?.required"
                                    class="error">Please select default check</p>
                            </td> -->
                            <!-- <td>
                                <input type="file" class="form-control-file" formControlName="bankDocument"
                                    [ngClass]="{'is-invalid': (submitted || rf.bankAccountDTOList['controls'][i]['controls'].bankDocument.touched) && rf.bankAccountDTOList['controls'][i]['controls'].bankDocument.errors}">
                                <p *ngIf="(submitted || rf.bankAccountDTOList['controls'][i]['controls'].bankDocument.touched) && rf.bankAccountDTOList['controls'][i]['controls'].bankDocument.errors?.required"
                                    class="error">Please upload bank statement for last 6 months</p>
                            </td> -->
                            <!-- <td>
                                <button *ngIf="i==rf.bankAccountDTOList['controls'].length-1"
                                    class="btn btn-primary btn-sm" (click)="addNewBank()">+ Add</button>
                                <button *ngIf="i<rf.bankAccountDTOList['controls'].length-1"
                                    class="btn btn-secondary btn-sm" (click)="deleteBankItem(i)">
                                    <i class="fa fa-trash pointer"></i> Delete
                                </button>
                            </td> -->
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- table end -->
        </div>
        <!-- DP Accounts -->
        <div class="card mt-3 colorborder col-lg-12">
            <div class="card card-header">
                <h3>Participant DP Accounts</h3>
            </div>
            <div class="card card-body table-responsive">
                <table class="table common-table common-table">
                    <thead>
                        <tr>
                            <th>Sr. No.</th>
                            <th>DP Type<!--<span class="red">*</span>--></th>
                            <th>DP ID<!--<span class="red">*</span>--></th>
                            <th>Re-Enter DP ID<!--<span class="red">*</span>--></th>
                            <th>Beneficiary ID<!--<span class="red">*</span>--></th>
                            <th>Re-Enter Beneficiary ID<!--<span class="red">*</span>--></th>
                            <!-- <th>Default <span class="red">*</span></th> -->
                            <!-- <th>Upload CML File<span class="red">*</span></th> -->
                            <!-- <th></th> -->
                        </tr>
                    </thead>
                    <tbody formArrayName="dpAccountDTOList">
                        <tr *ngFor="let data of rf.dpAccountDTOList['controls']; let i=index" [formGroupName]="i">
                            <td>{{i+1}}</td>
                            <td>
                                <select class="form-control form-control-sm selectpicker" formControlName="dpType"
                                    title="Select DP Type"
                                    [ngClass]="{'is-invalid': (submitted || rf.dpAccountDTOList['controls'][i]['controls'].dpType.touched) && rf.dpAccountDTOList['controls'][i]['controls'].dpType.errors}">
                                    <option value="">Select DP Type</option>
                                    <option value="NSDL">NSDL</option>
                                    <option value="CDSL">CDSL</option>
                                </select>
                                <!-- <p *ngIf="(submitted || rf.dpAccountDTOList['controls'][i]['controls'].dpType.touched) && rf.dpAccountDTOList['controls'][i]['controls'].dpType.errors?.required"
                                    class="error">Please select DP Type</p> -->
                            </td>
                            <td>
                                <input type="password" class="form-control form-control-sm"
                                    [required]="rf.dpAccountDTOList['controls'][i]['controls'].dpType.value=='NSDL'"
                                    [attr.disabled]="rf.dpAccountDTOList['controls'][i]['controls'].dpType.value=='CDSL'?true:null"
                                    formControlName="dpID"
                                    [ngClass]="{'is-invalid': (submitted || rf.dpAccountDTOList['controls'][i]['controls'].dpID.touched) && rf.dpAccountDTOList['controls'][i]['controls'].dpID.errors}" autocomplete="off">
                                <!-- <p *ngIf="(submitted || rf.dpAccountDTOList['controls'][i]['controls'].dpID.touched) && rf.dpAccountDTOList['controls'][i]['controls'].dpID.errors?.required"
                                    class="error">Please enter DP ID</p> -->
                            </td>
                            <td>
                                <input type="text" class="form-control form-control-sm"
                                    [required]="rf.dpAccountDTOList['controls'][i]['controls'].dpType.value=='NSDL'"
                                    [attr.disabled]="rf.dpAccountDTOList['controls'][i]['controls'].dpType.value=='CDSL'?true:null"
                                    formControlName="reenteredDpID"
                                    [ngClass]="{'is-invalid': (submitted || rf.dpAccountDTOList['controls'][i]['controls'].reenteredDpID.touched) && rf.dpAccountDTOList['controls'][i]['controls'].reenteredDpID.errors}" autocomplete="off">
                                <!-- <p *ngIf="(submitted || rf.dpAccountDTOList['controls'][i]['controls'].reenteredDpID.touched) && rf.dpAccountDTOList['controls'][i]['controls'].reenteredDpID.errors?.required"
                                    class="error">Please enter DP ID</p> -->
                                <p *ngIf="(submitted || rf.dpAccountDTOList['controls'][i]['controls'].reenteredDpID.touched) && rf.dpAccountDTOList['controls'][i]['controls'].reenteredDpID.errors?.matching"
                                    class="error">Re-entered DP ID should be same as DP ID</p>
                            </td>
                            <td><input type="password" class="form-control form-control-sm"
                                    formControlName="beneficiaryID"
                                    [ngClass]="{'is-invalid': (submitted || rf.dpAccountDTOList['controls'][i]['controls'].beneficiaryID.touched) && rf.dpAccountDTOList['controls'][i]['controls'].beneficiaryID.errors}" autocomplete="off">
                                <!-- <p *ngIf="(submitted || rf.dpAccountDTOList['controls'][i]['controls'].beneficiaryID.touched) && rf.dpAccountDTOList['controls'][i]['controls'].beneficiaryID.errors?.required"
                                    class="error">Please enter Beneficiary ID</p> -->
                            </td>
                            <td><input type="text" class="form-control form-control-sm"
                                    formControlName="reenterBeneficiaryID"
                                    [ngClass]="{'is-invalid': (submitted || rf.dpAccountDTOList['controls'][i]['controls'].reenterBeneficiaryID.touched) && rf.dpAccountDTOList['controls'][i]['controls'].reenterBeneficiaryID.errors}" autocomplete="off">
                                <!-- <p *ngIf="(submitted || rf.dpAccountDTOList['controls'][i]['controls'].reenterBeneficiaryID.touched) && rf.dpAccountDTOList['controls'][i]['controls'].reenterBeneficiaryID.errors?.required"
                                    class="error">Please enter Beneficiary ID</p> -->
                                <p *ngIf="(submitted || rf.dpAccountDTOList['controls'][i]['controls'].reenterBeneficiaryID.touched) && rf.dpAccountDTOList['controls'][i]['controls'].reenterBeneficiaryID.errors?.matching"
                                    class="error">Re-entered Beneficiary ID should be same as Beneficiary ID</p>
                            </td>
                            <!-- <td>
                                <div class="form-check form-check-inline">
                                    <input type="radio" formControlName="defaultAccount" name="defaultDP{{i}}"
                                        id="defaultYes" value="Y" class="form-check-input"
                                        [ngClass]="{'is-invalid': submitted && rf.dpAccountDTOList['controls'][i]['controls'].defaultAccount.errors}">
                                    <label class="form-check-label" for="defaultYes">Yes</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input type="radio" formControlName="defaultAccount" name="defaultDP{{i}}"
                                        id="defaultNo" value="N" class="form-check-input"
                                        [ngClass]="{'is-invalid': submitted && rf.dpAccountDTOList['controls'][i]['controls'].defaultAccount.errors}">
                                    <label class="form-check-label" for="defaultNo">No</label>
                                </div>
                            </td> -->
                            <!-- <td><input type="file" class="form-control-file" formControlName="dpDocument"
                                    [ngClass]="{'is-invalid': (submitted || rf.dpAccountDTOList['controls'][i]['controls'].dpDocument.touched) && rf.dpAccountDTOList['controls'][i]['controls'].dpDocument.errors}">
                                <p *ngIf="(submitted || rf.dpAccountDTOList['controls'][i]['controls'].dpDocument.touched) && rf.dpAccountDTOList['controls'][i]['controls'].dpDocument.errors?.required"
                                    class="error">Please upload DP document</p>
                            </td> -->
                            <!-- <td>
                                <button *ngIf="i==rf.dpAccountDTOList['controls'].length-1"
                                    class="btn btn-primary btn-sm" (click)="addNewDP()">+ Add</button>
                                <button *ngIf="i<rf.dpAccountDTOList['controls'].length-1"
                                    class="btn btn-secondary btn-sm" (click)="deleteDPAccountItem(i)">
                                    <i class="fa fa-trash pointer"></i> Delete
                                </button>
                            </td> -->
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="card mt-3 colorborder col-lg-12">
            <div class="card card-header">
                <h3>KYC Documents <small>(Upload Scanned Copies)</small></h3>
                <i class="bi bi-info-circle"></i>
            </div>
            <div class="card card-body">
                <div class="row " formArrayName="kycDocList">
                    <div class="col-lg-3 form-group" *ngFor="let kycFile of kycDocList; let i=index"
                        [formGroupName]="i">
                        <label>{{kycFile.value}}<!--<span class="red">*</span>--></label>
                        <input type="file" class="form-control-file" formControlName="kycFile" #file
                            (change)="uploadRegisterFile(file, kycFile.key,i)" 
                            *ngIf="user?.entityType!='ADMIN' && !this.responseData.loginID" accept="application/pdf"
                            [ngClass]="{'is-invalid': (submitted || rf.kycDocList['controls'][i]['controls'].kycFile.touched) && rf.kycDocList['controls'][i]['controls'].kycFile.errors}"><!--[required]="action=='add'"-->
                        <!-- <p *ngIf="user?.entityType!='ADMIN' && !this.responseData.loginID && (submitted || rf.kycDocList['controls'][i]['controls'].kycFile.touched) && rf.kycDocList['controls'][i]['controls'].kycFile.errors && !this.pdfFileError[i]"
                            class="error"> Please upload document</p> -->
                        <p *ngIf="this.pdfFileError[i] " class="error">
                            Please upload pdf file
                        </p>
                        <a *ngIf="kycFile.fileName" class="btn btn-link nocase"
                            (click)="downloadFile(kycFile.fileName)">{{kycFile.fileName}}
                            <i class="fa fa-download"></i></a>
                    </div>
                </div>
                <!-- <div class="noteList">
                    Note :-
                    <ul>
                        <li>In case of direct participants, all the KYC documents need to be uploaded.</li>
                        <li>For custodian settlement, only upload Application letter (Annexure 4) and self-attested
                            copy of PAN card.</li>
                        <li>All documents to be stamped and signed by authorised signatories.</li>
                    </ul>
                </div> -->
            </div>
        </div>
        <!-- Additional Information -->
        <div class="card mt-3 colorborder col-lg-12">
            <div class="card card-header">
                <h3>Additional Information</h3>
            </div>
            <div class="card card-body">
                <div class="row" formArrayName="additionalDtlsDTOList">
                    <div class="col-lg-3 form-group mt-2" *ngFor="let info of additionalInfo; let i=index"
                        [formGroupName]="i">
                        <ng-container *ngIf="info.type=='radio'">
                            <legend class="mt-1 nocase">{{info.value}}<!--<span class="red">*</span>--></legend>
                            <div class="form-check form-check-inline">
                                <input type="radio" formControlName="fieldValue" id="fieldValueY{{i}}" value="Y"
                                    class="form-check-input"
                                    [ngClass]="{'is-invalid': submitted && rf.additionalDtlsDTOList['controls'][i]['controls'].fieldValue.errors}">
                                <label class="form-check-label" for="fieldValueY">Yes</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" formControlName="fieldValue" id="fieldValueN{{i}}" value="N"
                                    class="form-check-input"
                                    [ngClass]="{'is-invalid': (submitted || rf.additionalDtlsDTOList['controls'][i]['controls'].fieldValue.touched) && rf.additionalDtlsDTOList['controls'][i]['controls'].fieldValue.errors}">
                                <label class="form-check-label" for="fieldValueN">No</label>
                            </div>
                            <!-- <p *ngIf="(submitted || rf.additionalDtlsDTOList['controls'][i]['controls'].fieldValue.touched) && rf.additionalDtlsDTOList['controls'][i]['controls'].fieldValue.errors"
                                class="error"> Please select the value</p> -->
                        </ng-container>
                        <ng-container *ngIf="info.type=='number'">
                            <label class="nocase">{{info.value}}<!--<span class="red">*</span>--></label>
                            <input type="number" class="form-control form-control-sm" formControlName="fieldValue"
                                [ngClass]="{'is-invalid': submitted && rf.additionalDtlsDTOList['controls'][i]['controls'].fieldValue.errors}" autocomplete="off">
                            <!-- <p *ngIf="(submitted || rf.additionalDtlsDTOList['controls'][i]['controls'].fieldValue.touched) && rf.additionalDtlsDTOList['controls'][i]['controls'].fieldValue.errors?.required"
                                class="error">Please enter value</p> -->
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
        <!-- Submit -->
        <!-- <div class="card mt-3 colorborder col-lg-12" *ngIf="user?.entityType!='ADMIN'"> -->
        <!-- <div class="card card-header">
                <h3>Captcha</h3>
            </div>
            <div class="card card-body">
                <div class="row">
                    <div class="col-lg-3 form-group">
                        <div class="row">
                            <div class="col-lg-10">
                                <div class="captcha-frame"><img class='imgCaptcha' src="{{captchaSource}}">
                                </div>
                            </div>
                            <div class="col-lg-2">
                                <div class=" captcha-frame mlspacing"><svg class="reloadimg" version="1.1" id="Capa_1"
                                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                        x="0px" y="0px" viewBox="0 0 477.867 477.867"
                                        style="enable-background:new 0 0 477.867 477.867;" xml:space="preserve"
                                        (click)="reloadCaptcha()">
                                        <g>
                                            <g>
                                                <path d="M409.6,0c-9.426,0-17.067,7.641-17.067,17.067v62.344C304.667-5.656,164.478-3.386,79.411,84.479
                                       c-40.09,41.409-62.455,96.818-62.344,154.454c0,9.426,7.641,17.067,17.067,17.067S51.2,248.359,51.2,238.933
                                       c0.021-103.682,84.088-187.717,187.771-187.696c52.657,0.01,102.888,22.135,138.442,60.976l-75.605,25.207
                                       c-8.954,2.979-13.799,12.652-10.82,21.606s12.652,13.799,21.606,10.82l102.4-34.133c6.99-2.328,11.697-8.88,11.674-16.247v-102.4
                                       C426.667,7.641,419.026,0,409.6,0z" />
                                            </g>
                                        </g>
                                        <g>
                                            <g>
                                                <path
                                                    d="M443.733,221.867c-9.426,0-17.067,7.641-17.067,17.067c-0.021,103.682-84.088,187.717-187.771,187.696
                                       c-52.657-0.01-102.888-22.135-138.442-60.976l75.605-25.207c8.954-2.979,13.799-12.652,10.82-21.606
                                       c-2.979-8.954-12.652-13.799-21.606-10.82l-102.4,34.133c-6.99,2.328-11.697,8.88-11.674,16.247v102.4
                                       c0,9.426,7.641,17.067,17.067,17.067s17.067-7.641,17.067-17.067v-62.345c87.866,85.067,228.056,82.798,313.122-5.068
                                       c40.09-41.409,62.455-96.818,62.344-154.454C460.8,229.508,453.159,221.867,443.733,221.867z" />
                                            </g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                        <g>
                                        </g>
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 form-group">
                        <label>Enter Displayed Text<span class="red">*</span></label>
                        <input type="text" class="form-control" formControlName="captcha" [pattern]="captchaPattern"
                            [ngClass]="{ 'is-invalid': (submitted|| rf.captcha.touched) && rf.captcha.errors }"
                            autocomplete="off">
                        <p *ngIf="rf.captcha.invalid && rf.captcha.touched && rf.captcha.errors?.required"
                            class="error nocase">
                            Captcha is required
                        </p>
                        <p *ngIf="rf.captcha.invalid && rf.captcha.touched && rf.captcha.errors?.pattern"
                            class="error nocase">
                            Please enter a valid captcha
                        </p>
                    </div>
                </div> -->
        <div class="col-lg-12 mt-3" *ngIf="user?.entityType!='ADMIN'">
            <button class="btn btn-primary" (click)="register()" *ngIf="!responseData?.loginID">Register</button>
            <!-- <button class="btn btn-cancel ml-2" type="button" routerLink="../">Cancel</button> -->
            <button class="btn btn-cancel ml-2" type="button" (click)="cancel()">Cancel</button>
        </div>
        <!-- </div> -->
    </div>
</form>
<form [formGroup]='makerCheckerForm' *ngIf="user?.entityType=='ADMIN'">
    <div class="card mt-3 colorborder">
        <div class="card card-header">
            <h3>User Approval</h3>
        </div>
        <div class="card card-body">
            <div class="row">
                <div class="col-lg-3 form-group">
                    <label>Checker Remarks</label>
                    <textarea class="form-control" contenteditable formControlName="makerComment"></textarea>
                </div>
                <div class="col-lg-5 mt-4">
                    <button class="btn btn-primary" aria-hidden="true" data-toggle="modal"
                        *ngIf="!responseData?.loginID" data-target="#approveForm">Approve</button>
                    <button class="btn btn-secondary ml-2" aria-hidden="true" data-toggle="modal"
                        *ngIf="!responseData?.loginID" data-target="#rejectForm">Reject</button>
                    <button class="btn btn-secondary ml-2" aria-hidden="true" routerLink="../">Cancel</button>
                </div>
                <div class="col-lg-4 mt-4">
                    <button class="btn btn-primary" type="button" data-toggle="modal" data-target="#accessDtls">Access
                        Details</button>
                </div>
            </div>
        </div>
    </div>
</form>
<div class="modal fade" id="approveForm" tabindex="-1" role="dialog" aria-labelledby="approveModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <button type="button" class="close d-flex justify-content-end mr-2" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
            <div class="modal-body text-center">
                <h6>Are you sure you want to Approve this submission?</h6>
                <div class="d-flex justify-content-center mt-3">
                    <div class="col-3"><button type="button" class="btn btn-primary full-width" data-dismiss="modal"
                            (click)="makerCheckerAction('CHECKER_APPROVED');">Yes</button>
                    </div>
                    <div class="col-3"><button type="button" class="btn btn-secondary full-width"
                            data-dismiss="modal">No</button></div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="rejectForm" tabindex="-1" role="dialog" aria-labelledby="rejectModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <button type="button" class="close d-flex justify-content-end mr-2" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
            <div class="modal-body text-center">
                <h6>Are you sure you want to Reject this submission?</h6>
                <div class="d-flex justify-content-center mt-3">
                    <div class="col-3"><button type="button" class="btn btn-primary full-width" data-dismiss="modal"
                            (click)="makerCheckerAction2('CHECKER_REJECTED');">Yes</button>
                    </div>
                    <div class="col-3"><button type="button" class="btn btn-secondary full-width"
                            data-dismiss="modal">No</button></div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="accessDtls" tabindex="-1" role="dialog" aria-labelledby="accessDtlsLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <button type="button" class="close d-flex justify-content-end mr-2" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
            <div class="modal-body text-center">
                <div class="card card-body">
                    <form [formGroup]="userAccessForm">
                        <table class="table common-table access-table ">
                            <thead>
                                <tr>
                                    <th class="pre-wrap">Menu</th>
                                    <th class="pre-wrap">Access Requested</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngIf="accessMapping" formArrayName="accessMapping">
                                    <ng-container *ngFor="let menuAccess of accessMapping.controls;let i=index"
                                        [formGroupName]="i">
                                        <tr>
                                            <td class="title"><strong>{{menuAccess.value.menuName}}</strong> </td>
                                            <td>
                                                <svg *ngIf="menuAccess.value.isAccessAllowed=='N'"
                                                    xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    fill="currentColor" class="bi bi-check-square" viewBox="0 0 16 16">
                                                    <path
                                                        d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                                                    <path
                                                        d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.235.235 0 0 1 .02-.022z" />
                                                </svg>
                                                <svg *ngIf="menuAccess.value.isAccessAllowed=='Y'"
                                                    xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    fill="currentColor" class="fillColor bi bi-check-square-fill"
                                                    viewBox="0 0 16 16">
                                                    <path
                                                        d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm10.03 4.97a.75.75 0 0 1 .011 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.75.75 0 0 1 1.08-.022z" />
                                                </svg>
                                            </td>
                                        </tr>
                                        <ng-container formArrayName="userMenusImpls">
                                            <ng-container
                                                *ngFor="let subMenuAccess of menuAccess.get('userMenusImpls').controls; let j=index"
                                                [formGroupName]="j">
                                                <tr>
                                                    <td>&nbsp;&nbsp;&nbsp;&nbsp;<strong>{{subMenuAccess.value.menuName}}</strong>
                                                    </td>
                                                    <td>
                                                        <svg *ngIf="subMenuAccess.value.isAccessAllowed=='N'"
                                                            xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                            fill="currentColor" class="bi bi-check-square"
                                                            viewBox="0 0 16 16">
                                                            <path
                                                                d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                                                            <path
                                                                d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.235.235 0 0 1 .02-.022z" />
                                                        </svg>
                                                        <svg *ngIf="subMenuAccess.value.isAccessAllowed=='Y'"
                                                            xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                            fill="currentColor"
                                                            class="fillColor bi bi-check-square-fill"
                                                            viewBox="0 0 16 16">
                                                            <path
                                                                d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm10.03 4.97a.75.75 0 0 1 .011 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.75.75 0 0 1 1.08-.022z" />
                                                        </svg>
                                                    </td>
                                                </tr>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </tbody>
                        </table>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="memCodeCreation" tabindex="-1" role="dialog" aria-labelledby="rejectModalLabel"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <button type="button" class="close d-flex justify-content-end mr-2" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
            <div class="modal-body text-center">
                <h3>Set Member Code</h3>
                <form [formGroup]="memCodeCreation">
                    <div class="row justify-content-center">
                        <div class="col-lg-10">
                            <div class="input-group input-group-sm">
                                <!-- <div class="input-group-prepend">
                                    <div class="input-group-text">
                                        <h4>{{memCode}}</h4>
                                    </div>
                                </div> -->
                                <input type="text" class="form-control memCodeClass" formControlName="memCodeField1"
                                    maxlength="1">
                                <input type="text" class="form-control memCodeClass" formControlName="memCodeField2"
                                    maxlength="1">
                                <input type="text" class="form-control memCodeClass" formControlName="memCodeField3"
                                    maxlength="1">
                                <input type="text" class="form-control memCodeClass" formControlName="memCodeField4"
                                    maxlength="1">
                                <input type="text" class="form-control memCodeClass" formControlName="memCodeField5"
                                    maxlength="1">
                                <input type="text" class="form-control memCodeClass" formControlName="memCodeField6"
                                    maxlength="1">
                                <!-- <div class="input-group-append">
                                    <div class="input-group-text">
                                        <h4>XXXX</h4>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                    <p class="error"
                        *ngIf="(memCodeCreation.controls.memCodeField1.touched && memCodeCreation.controls.memCodeField1.invalid) || (memCodeCreation.controls.memCodeField2.touched && memCodeCreation.controls.memCodeField2.invalid) || (memCodeCreation.controls.memCodeField3.touched && memCodeCreation.controls.memCodeField3.invalid) || (memCodeCreation.controls.memCodeField4.touched && memCodeCreation.controls.memCodeField4.invalid)">
                        Please enter valid member code</p>
                    <div class="d-flex justify-content-center mt-3">
                        <div class="col-3"><button type="button" class="btn btn-primary full-width" data-dismiss="modal"
                                (click)="makerCheckerAction2('CHECKER_APPROVED');">Yes</button>
                        </div>
                        <div class="col-3"><button type="button" class="btn btn-secondary full-width"
                                data-dismiss="modal">No</button></div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>